export const updatesData = [
  { id: 1, date: '2026-07-30', title: '《星际穿越》4K修复版上线，诺兰科幻神作震撼回归', tag: '新片上线', accent: true },
  { id: 2, date: '2026-07-28', title: '暑期档热播剧《长风渡》全集一次性放出，会员抢先看', tag: '剧集更新', accent: false },
  { id: 3, date: '2026-07-26', title: '平台服务器全面升级完成，4K片源加载速度提升60%', tag: '平台公告', accent: false },
  { id: 4, date: '2026-07-24', title: '韩国犯罪悬疑片《杀人者的记忆法》高分引进上线', tag: '独家引进', accent: true },
  { id: 5, date: '2026-07-22', title: '国产动画《深海》获东京动画奖，平台独家4K呈现', tag: '获奖佳片', accent: false },
  { id: 6, date: '2026-07-20', title: '日剧《重启人生》全集上线，豆瓣9.4分口碑炸裂', tag: '高分推荐', accent: true },
  { id: 7, date: '2026-07-18', title: '新增「杜比全景声」专区，沉浸式观影体验全新升级', tag: '功能升级', accent: false },
  { id: 8, date: '2026-07-15', title: '经典港片修复计划启动，《无间道》系列率先上架', tag: '经典修复', accent: false },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-4k-line',
    title: '真高清画质',
    desc: '支持1080P至4K超清播放，采用H.265高效编码，画质细腻色彩真实，让每一帧都如临其境。',
  },
  {
    id: 2,
    icon: 'ri-speed-up-line',
    title: '极速不缓冲',
    desc: '全球CDN加速节点覆盖，智能码率自适应技术。无论宽带还是移动网络，都能畅享零等待的流畅观影。',
  },
  {
    id: 3,
    icon: 'ri-film-line',
    title: '海量片库',
    desc: '汇集全球热门电影、高分剧集、经典老片、热门综艺。每日更新，类型覆盖动作、悬疑、喜剧、爱情、科幻等全品类。',
  },
];

export const rankingData = [
  { rank: 1, title: '流浪地球3', hot: '986万', category: '科幻', trend: 'up', isNew: true },
  { rank: 2, title: '长风渡', hot: '872万', category: '古装', trend: 'up', isNew: false },
  { rank: 3, title: '消失的她', hot: '765万', category: '悬疑', trend: 'hot', isNew: false },
  { rank: 4, title: '封神第二部', hot: '698万', category: '奇幻', trend: 'up', isNew: true },
  { rank: 5, title: '狂飙', hot: '654万', category: '犯罪', trend: 'stable', isNew: false },
  { rank: 6, title: '奥本海默', hot: '589万', category: '传记', trend: 'up', isNew: false },
  { rank: 7, title: '繁花', hot: '532万', category: '年代', trend: 'stable', isNew: false },
];

export const appData = {
  title: '随时随地，高清随行',
  subtitle: '久播影院移动端完美适配，手机、平板、电脑无缝切换。离线缓存功能让你无网也能看，通勤旅途不再无聊。',
  features: ['全设备自适应', '离线缓存观看', '画质随心切换', '跨端进度同步'],
};

export const commentsData = [
  {
    id: 1,
    name: '影迷小陈',
    avatar: '陈',
    rating: 5,
    content: '用了很多个影视平台，久播的画质是真的好！4K片源很全，而且基本不卡顿，晚高峰也能流畅看。强烈推荐给追求画质的朋友。',
    movie: '流浪地球3',
    date: '2026-07-28',
  },
  {
    id: 2,
    name: '追剧达人Linda',
    avatar: '琳',
    rating: 5,
    content: '追《长风渡》的时候发现这里更新最快！其他平台还在更一半，这边全集都上了。而且没有烦人的弹窗广告，体验一级棒。',
    movie: '长风渡',
    date: '2026-07-25',
  },
  {
    id: 3,
    name: '电影老炮儿',
    avatar: '张',
    rating: 4,
    content: '作为一个看了二十多年电影的老影迷，久播的片库让我很惊喜。很多冷门文艺片和经典老片都能找到，片源质量也很稳定。',
    movie: '奥本海默',
    date: '2026-07-22',
  },
  {
    id: 4,
    name: '学生党小王',
    avatar: '王',
    rating: 5,
    content: '学生党福音！免费就能看高清，宿舍网速一般也不影响。最近复习累了就刷一部电影放松，分类很清晰找片子超方便。',
    movie: '深海',
    date: '2026-07-20',
  },
];

export const mediaData = [
  {
    id: 1,
    title: '本周必看：诺兰科幻三部曲',
    desc: '从《盗梦空间》到《星际穿越》再到《信条》，诺兰用电影语言重新定义了科幻的边界。',
    tag: '导演专题',
    duration: '合集',
    image: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20film%20reel%20aesthetic%20with%20warm%20golden%20light%20rays%2C%20movie%20atmosphere%2C%20soft%20focus%20bokeh%20effect%2C%20elegant%20dark%20theater%20mood%2C%20dramatic%20lighting%20with%20subtle%20vintage%20texture%2C%20professional%20cinematography%20style&width=800&height=500&seq=media-card-1&orientation=landscape',
  },
  {
    id: 2,
    title: '国产动画崛起之路',
    desc: '《哪吒》《深海》《长安三万里》——中国动画电影的黄金时代已经到来，每一部都值得细品。',
    tag: '行业观察',
    duration: '专题',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20film%20aesthetic%20with%20ink%20wash%20painting%20style%2C%20warm%20golden%20particles%20floating%2C%20dreamy%20atmosphere%2C%20dark%20moody%20background%2C%20elegant%20artistic%20composition%2C%20subtle%20light%20effects&width=800&height=500&seq=media-card-2&orientation=landscape',
  },
  {
    id: 3,
    title: '暑期档观影指南2026',
    desc: '这个夏天有哪些不容错过的院线大片和平台新片？我们为你整理了最全观影清单。',
    tag: '观影指南',
    duration: '策划',
    image: 'https://readdy.ai/api/search-image?query=Summer%20cinema%20vibes%20with%20warm%20sunset%20golden%20hour%20lighting%2C%20film%20projector%20beam%2C%20atmospheric%20movie%20theater%20mood%2C%20dark%20dramatic%20shadows%2C%20nostalgic%20film%20aesthetic%2C%20professional%20photography&width=800&height=500&seq=media-card-3&orientation=landscape',
  },
  {
    id: 4,
    title: '悬疑片爱好者必收片单',
    desc: '从《看不见的客人》到《消失的她》，反转再反转的烧脑佳作一次性推荐给你。',
    tag: '片单推荐',
    duration: '精选',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20cinematic%20atmosphere%20with%20shadow%20and%20light%20contrast%2C%20dramatic%20noir%20lighting%2C%20dark%20moody%20scenes%2C%20film%20noir%20aesthetic%20with%20warm%20amber%20highlights%2C%20suspenseful%20mood&width=800&height=500&seq=media-card-4&orientation=landscape',
  },
];

export const carouselData = [
  {
    id: 1,
    title: '科幻巨制《流浪地球3》',
    desc: '中国科幻电影的里程碑之作，太阳系危机再次降临，人类命运何去何从？',
    tag: '热播推荐',
    category: '科幻',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20film%20poster%20aesthetic%20with%20dramatic%20space%20lighting%2C%20warm%20golden%20and%20deep%20blue-gray%20tones%2C%20epic%20movie%20atmosphere%2C%20professional%20photography%20style%2C%20dark%20moody%20background%20with%20subtle%20film%20grain%20texture&width=900&height=600&seq=carousel-1&orientation=landscape',
  },
  {
    id: 2,
    title: '古装大剧《长风渡》',
    desc: '白敬亭宋轶再度携手，乱世中相知相守的动人故事，暑期档必追古装巨制。',
    tag: '剧集热播',
    category: '古装',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20aesthetic%20with%20warm%20lantern%20light%2C%20traditional%20architecture%20silhouette%2C%20golden%20amber%20tones%2C%20romantic%20atmospheric%20mood%2C%20cinematic%20composition%2C%20elegant%20ancient%20Chinese%20style&width=900&height=600&seq=carousel-2&orientation=landscape',
  },
  {
    id: 3,
    title: '悬疑神作《消失的她》',
    desc: '朱一龙、倪妮领衔主演，层层反转的东南亚迷局，真相远比想象更加残酷。',
    tag: '高分推荐',
    category: '悬疑',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20cinematic%20poster%20with%20tropical%20night%20atmosphere%2C%20deep%20shadows%20and%20warm%20neon%20highlights%2C%20suspenseful%20mood%2C%20dark%20moody%20tones%2C%20professional%20film%20photography%20style%20with%20rich%20contrast&width=900&height=600&seq=carousel-3&orientation=landscape',
  },
  {
    id: 4,
    title: '经典修复《无间道》系列',
    desc: '香港警匪片巅峰之作4K修复版，梁朝伟刘德华的世纪对决，每一帧都是经典。',
    tag: '经典回顾',
    category: '犯罪',
    image: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20crime%20film%20noir%20aesthetic%20with%20rooftop%20scene%20silhouette%2C%20dramatic%20contrast%20lighting%2C%20warm%20amber%20and%20cool%20shadow%20tones%2C%20classic%20cinema%20mood%2C%20professional%20cinematography&width=600&height=400&seq=carousel-wide-4&orientation=landscape',
  },
  {
    id: 5,
    title: '动画佳作《深海》',
    desc: '田晓鹏导演历时七年打造的视觉奇观，粒子水墨惊艳世界，献给每一个走过长夜的你。',
    tag: '获奖佳片',
    category: '动画',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20deep%20sea%20fantasy%20scene%20with%20colorful%20particle%20effects%2C%20ink%20wash%20style%2C%20dreamy%20underwater%20atmosphere%2C%20warm%20golden%20light%20rays%2C%20artistic%20and%20beautiful%20composition&width=600&height=400&seq=carousel-wide-5&orientation=landscape',
  },
];

export const aboutData = {
  title: '关于久播影院',
  content: '久播影院成立于2020年，是专注于高清影视内容聚合与分发的在线观影平台。我们致力于为华语观众提供免费、高清、流畅的在线观影体验，汇聚全球优质电影、电视剧、综艺、动漫等海量内容资源。',
  highlights: [
    { value: '10万+', label: '影视资源' },
    { value: '5000万+', label: '月活跃用户' },
    { value: '4K HDR', label: '画质标准' },
    { value: '99.9%', label: '服务可用率' },
  ],
};

export const faqData = [
  {
    id: 1,
    question: '久播影院真的完全免费吗？',
    answer: '是的，久播影院所有影视内容均免费提供在线观看。我们通过广告合作和技术优化来维持平台运营，用户无需支付任何费用即可享受高清流畅的观影体验。',
  },
  {
    id: 2,
    question: '观看需要安装播放器或插件吗？',
    answer: '不需要。久播影院采用先进的H5播放技术，直接在浏览器中即可播放，无需安装任何第三方播放器、插件或APP。支持Chrome、Safari、Edge等主流浏览器。',
  },
  {
    id: 3,
    question: '为什么有的影片加载速度比较慢？',
    answer: '影片加载速度受网络环境、同时在线人数和片源服务器等因素影响。建议选择标清画质观看、避开晚高峰时段，或切换至移动网络尝试。我们也在持续优化CDN加速节点。',
  },
  {
    id: 4,
    question: '支持哪些设备观看？画质如何？',
    answer: '久播影院完美支持PC、平板、手机等全设备自适应观看。画质方面提供流畅、高清、超清和4K四档选择，根据您的网络状况和设备性能自动推荐最佳画质。',
  },
  {
    id: 5,
    question: '如何快速找到想看的影片？',
    answer: '您可以使用顶部搜索框输入片名、演员或导演关键词搜索，也可通过首页的分类索引、热播榜单、精选专题等模块浏览。我们还提供个性化推荐，越用越懂您的口味。',
  },
];

export const indexData = [
  { id: 1, title: '动作片', icon: 'ri-sword-line', count: 2836, color: 'accent' },
  { id: 2, title: '喜剧片', icon: 'ri-emotion-laugh-line', count: 1954, color: 'primary' },
  { id: 3, title: '爱情片', icon: 'ri-heart-line', count: 1678, color: 'accent' },
  { id: 4, title: '科幻片', icon: 'ri-rocket-line', count: 1234, color: 'primary' },
  { id: 5, title: '悬疑片', icon: 'ri-search-eye-line', count: 1567, color: 'accent' },
  { id: 6, title: '恐怖片', icon: 'ri-ghost-line', count: 892, color: 'primary' },
  { id: 7, title: '动画片', icon: 'ri-palette-line', count: 2103, color: 'accent' },
  { id: 8, title: '纪录片', icon: 'ri-camera-line', count: 1345, color: 'primary' },
  { id: 9, title: '战争片', icon: 'ri-shield-line', count: 678, color: 'accent' },
];

export const cardsData = [
  {
    id: 1,
    title: '流浪地球3',
    rating: 9.2,
    year: '2026',
    genre: '科幻 / 冒险',
    desc: '太阳系危机再度升级，人类面临终极抉择。吴京、刘德华领衔，中国科幻新高度。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20film%20poster%20with%20epic%20space%20scenes%20and%20warm%20golden%20planet%20light%2C%20dramatic%20lighting%2C%20atmospheric%20dark%20background%2C%20professional%20movie%20poster%20style%2C%20rich%20contrast&width=1200&height=675&seq=card-film-1&orientation=landscape',
  },
  {
    id: 2,
    title: '封神第二部',
    rating: 8.8,
    year: '2026',
    genre: '奇幻 / 史诗',
    desc: '殷商大战全面爆发，姜子牙率众仙迎战魔家四将，视觉特效全面升级。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20film%20poster%20with%20ancient%20warriors%20and%20magical%20effects%2C%20warm%20golden%20and%20crimson%20tones%2C%20epic%20battle%20atmosphere%2C%20dark%20moody%20background%2C%20professional%20film%20style&width=600&height=900&seq=card-film-2&orientation=portrait',
  },
  {
    id: 3,
    title: '消失的她',
    rating: 8.5,
    year: '2025',
    genre: '悬疑 / 犯罪',
    desc: '东南亚迷局层层反转，朱一龙演技炸裂，年度最值得二刷的悬疑佳作。',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20film%20poster%20with%20tropical%20night%20scene%20and%20neon%20light%20reflections%2C%20suspenseful%20atmosphere%2C%20warm%20amber%20and%20deep%20teal%20tones%2C%20dark%20moody%20vibe%2C%20cinematic%20composition&width=600&height=900&seq=card-film-3&orientation=portrait',
  },
  {
    id: 4,
    title: '奥本海默',
    rating: 8.9,
    year: '2024',
    genre: '传记 / 历史',
    desc: '诺兰执导史诗巨制，原子弹之父的内心挣扎。基里安·墨菲封神演技。',
    image: 'https://readdy.ai/api/search-image?query=Biographical%20historical%20film%20poster%20with%20mushroom%20cloud%20silhouette%20and%20intense%20portrait%20lighting%2C%20dramatic%20contrast%2C%20warm%20orange%20and%20black%20tones%2C%20atmospheric%20and%20powerful%2C%20professional%20movie%20poster&width=600&height=900&seq=card-film-4&orientation=portrait',
  },
  {
    id: 5,
    title: '深海',
    rating: 8.3,
    year: '2025',
    genre: '动画 / 奇幻',
    desc: '粒子水墨惊艳世界，田晓鹏七年匠心之作。献给每一个走过长夜的你。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20fantasy%20film%20poster%20with%20colorful%20underwater%20particle%20effects%2C%20ink%20wash%20painting%20style%2C%20dreamy%20atmosphere%2C%20warm%20golden%20light%20beams%2C%20artistic%20and%20beautiful%20composition&width=600&height=900&seq=card-film-5&orientation=portrait',
  },
];

export const topicsData = [
  { id: 1, name: '流浪地球3', heat: 986, posts: '12.8万', tag: '爆' },
  { id: 2, name: '诺兰电影', heat: 854, posts: '9.6万', tag: '热' },
  { id: 3, name: '暑期档推荐', heat: 732, posts: '8.2万', tag: '热' },
  { id: 4, name: '高分悬疑片', heat: 689, posts: '7.1万', tag: '热' },
  { id: 5, name: '国产动画', heat: 621, posts: '6.5万', tag: '' },
  { id: 6, name: '港片经典', heat: 567, posts: '5.8万', tag: '' },
  { id: 7, name: '韩国电影', heat: 498, posts: '4.9万', tag: '' },
  { id: 8, name: '豆瓣9分剧', heat: 456, posts: '4.3万', tag: '' },
  { id: 9, name: '奥斯卡影片', heat: 412, posts: '3.8万', tag: '' },
  { id: 10, name: '日剧推荐', heat: 378, posts: '3.2万', tag: '' },
  { id: 11, name: '纪录片精选', heat: 335, posts: '2.7万', tag: '' },
];

export const contactData = {
  title: '联系我们',
  intro: '欢迎优秀的内容创作者、影视爱好者与我们取得联系。无论是内容投稿、合作建议还是问题反馈，我们都会认真对待每一条信息。',
  email: 'contact@jiubo.tv',
  wechat: 'jiubo_cinema',
  qq: '10001',
};

export const navLinks = [
  { id: 'app', label: '移动观影', href: '#app' },
  { id: 'carousel', label: '精选专题', href: '#carousel' },
  { id: 'comments', label: '用户口碑', href: '#comments' },
  { id: 'faq', label: '常见问题', href: '#faq' },
  { id: 'contact', label: '联系投稿', href: '#contact' },
];